import { Center, HStack, Icon, Stack, Text } from "@chakra-ui/react";
import { PiGlobeSimple } from "react-icons/pi";

export const ChinaBanner = () => {
  return (
    <HStack gap="4" p="6" bg="#182A2D" borderRadius="xl" mb="6" w="full">
      <Center position="relative">
        <Icon as={PiGlobeSimple} h="6" w="6" color="#9DE6FC" />
      </Center>
      <Stack gap="0">
        <Text color="#FFFFFF">
          中国大陆用户请注意：依据相关法律法规，您可能无法合法访问或使用本网站的部分或全部服务。请在遵守适用法律的前提下谨慎操作。
        </Text>
      </Stack>
    </HStack>
  );
};
